module.exports = __webpack_public_path__ + "img/news_poster3.5b24eaae.png";